// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:7BosL4 */\n.ivtCA{align-items:center;color:var(--audio-exception-light);display:flex;height:2.5rem;justify-content:flex-end;padding:0 var(--audio-spacing-8);width:100%}._8ceSd{display:inline-flex}._7Aqj8{height:2rem;width:2rem}@media (min-width:768px){.ivtCA{padding:0 var(--audio-spacing-16)}}@media (min-width:1280px){.ivtCA{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "ivtCA",
	"iconButton": "_8ceSd",
	"icon": "_7Aqj8"
};
export default ___CSS_LOADER_EXPORT___;
